export const CUSTOM_DOTS_ALT = "custom dots";
